export default {"src":"/_next/static/media/return-green.f43b88e8.svg","height":24,"width":24};